import React, { useEffect, useState } from "react";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import {
  Container,
  Table,
  Row,
  Col,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Form,
} from "reactstrap";
import classnames from "classnames";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Department from "./Department";
import StaffSetting from "./ShiftTime";
import ShiftTime from "./ShiftTime";
import StaffLetters from "./StaffLetters/staffLetters";
import LetterType from "./StaffLetters/LetterType";
import GuidelinesPolicy from "./GuidelinesPolicy";

// components

const SettingIndex = () => {
  // const [verticalActiveTab, setverticalActiveTab] = useState("1")
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const tabFromURL = query.get("tab") || "1";
  const [verticalActiveTab, setverticalActiveTab] = useState(tabFromURL);
  const [fixedSideTab, setFixedSideTab] = useState(false);

  document.addEventListener("scroll", () => {
    if (window.scrollY > 68) {
      setFixedSideTab(true);
    } else {
      setFixedSideTab(false);
    }
  });

  document.title = "Staff  | Zithas Crm";

  // const toggleVertical = (tab) => {
  //   if (verticalActiveTab !== tab) {
  //     setverticalActiveTab(tab);
  //   }
  // };

  const navigate = useNavigate();
  const toggleVertical = (tab) => {
    if (verticalActiveTab !== tab) {
      setverticalActiveTab(tab);
      navigate(`?tab=${tab}`, { replace: true });
    }
  };

  useEffect(() => {
    setverticalActiveTab(tabFromURL);
  }, [tabFromURL]);

  return (
    <React.Fragment>
      <div className="page-content mb-4">
        <Container fluid>
          <Breadcrumbs title="Dashboard" breadcrumbItem="Company Setting" />

          <Row className="gx-4 justify-content-between di-flex align-items-top">
            <Col md="2" className="px-0">
              <Nav
                pills
                className={`side-tab flex-column px-2 py-3 bg-white
                            ${fixedSideTab ? "fixed-side-tab" : ""} h-100`}
              >
                <NavItem>
                  <NavLink
                    style={{ cursor: "pointer" }}
                    className={classnames({
                      "mb-2": true,
                      active: verticalActiveTab === "1",
                    })}
                    onClick={() => {
                      toggleVertical("1");
                    }}
                  >
                    Department
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    style={{ cursor: "pointer" }}
                    className={classnames({
                      "mb-2": true,
                      active: verticalActiveTab === "2",
                    })}
                    onClick={() => {
                      toggleVertical("2");
                    }}
                  >
                    Shift Time
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    style={{ cursor: "pointer" }}
                    className={classnames({
                      "mb-2": true,
                      active: verticalActiveTab === "3",
                    })}
                    onClick={() => {
                      toggleVertical("3");
                    }}
                  >
                    Document Types
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    style={{ cursor: "pointer" }}
                    className={classnames({
                      "mb-2": true,
                      active: verticalActiveTab === "4",
                    })}
                    onClick={() => {
                      toggleVertical("4");
                    }}
                  >
                    Document Template
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    style={{ cursor: "pointer" }}
                    className={classnames({
                      "mb-2": true,
                      active: verticalActiveTab === "5",
                    })}
                    onClick={() => {
                      toggleVertical("5");
                    }}
                  >
                    Guidelines & Policy
                  </NavLink>
                </NavItem>
              </Nav>
            </Col>
            <Col md="10">
              <div className="card bg-transparent mb-0">
                <TabContent
                  activeTab={verticalActiveTab}
                  className="text-muted mt-4 mt-md-0"
                >
                  <TabPane tabId="1">
                    <Department />
                  </TabPane>
                  <TabPane tabId="2">
                    <ShiftTime />
                  </TabPane>
                  <TabPane tabId="3" className="card bg-white p-4">
                    <LetterType />
                  </TabPane>
                  <TabPane tabId="4" className="card bg-white p-4">
                    <StaffLetters />
                  </TabPane>
                  <TabPane tabId="5" className="card bg-white p-4">
                    <GuidelinesPolicy />
                  </TabPane>
                </TabContent>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default SettingIndex;
